/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { pathConstants } from '../../constants';
import LandingPage from '../LandingPage';


const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const isUserLoggedIn = useAppSelector((state: any) => state.authentication.loggedIn);
  const userInfo = useAppSelector((state: any) => state.authentication.userInfo);

  useEffect(() => {
    // Nếu user đã login, redirect vào trang chính dựa vào role
    if (isUserLoggedIn && userInfo) {
      if (userInfo.role === 0 || userInfo.role === 1) {
        // Admin hoặc Teacher → Redirect to Lesson Diary Manage
        navigate(pathConstants.LESSON_DIARY_MANAGE);
      } else if (userInfo.role === 2) {
        // Student → Redirect to Student Page
        navigate(pathConstants.STUDENT_PAGE);
      }
    }
  }, [isUserLoggedIn, userInfo, navigate]);

  // Nếu chưa login, hiển thị landing page
  return <LandingPage />;
};

export default HomePage;
